// src/components/EmailVerificationAlert.jsx
import React, { useState } from 'react';
import { Alert, AlertDescription } from "./ui/alert";
import { Button } from "./ui/button";
import { useToast } from "./ui/use-toast";
import { supabase } from '../lib/supabase';
import { Mail, AlertTriangle } from "lucide-react";

export const EmailVerificationAlert = ({ email }) => {
  const [sending, setSending] = useState(false);
  const { toast } = useToast();

  const handleResendVerification = async () => {
    if (!email || sending) return;
    
    setSending(true);
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: email
      });
      
      if (error) throw error;
      
      toast({
        title: "Verification Email Sent",
        description: `Check your inbox at ${email} for the verification link.`,
        duration: 10000
      });
    } catch (error) {
      console.error('Error resending verification:', error);
      toast({
        title: "Error Sending Email",
        description: error.message || "Failed to send verification email. Please try again later.",
        variant: "destructive"
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Alert variant="destructive" className="mb-6">
      <AlertTriangle className="h-4 w-4 mr-2" />
      <AlertDescription className="flex flex-col sm:flex-row sm:items-center gap-2">
        <div className="flex-1">
          <strong>Email Verification Required:</strong> Please check your inbox and verify your email address to unlock full functionality.
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleResendVerification}
          disabled={sending}
          className="whitespace-nowrap"
        >
          <Mail className="h-4 w-4 mr-2" />
          {sending ? "Sending..." : "Resend Email"}
        </Button>
      </AlertDescription>
    </Alert>
  );
};